<template>
  <div class="faqPage">
    <div class="nav">
      <div class="caption">{{$t('lang.menu.FAQ')}}</div>
      <div class="navContainer">
        <div class="navItem pointer" v-for="(item, index) in faqList" :key="index" @click="setKey(item)">
          <div class="label" :class="{act: key === item.key}">{{item.label}}</div>
        </div>
      </div>
      <div class="logout pointer" @click="logout" v-if="isLogin">{{$t('lang.setting.logout')}}</div>
    </div>
    <div class="faqContainer">
      <faqDetail :detail="detail" />
    </div>
  </div>
</template>

<script>
import faqDetail from './children/FAQdetail'
export default {
  name: 'FAQ',
  data () {
    return {
      faqList: this.$t('lang.faqList'),
      detail: this.$t('lang.faqList')[0],
      key: 'common',
      isLogin: !!localStorage.getItem('userInfo')
    }
  },
  components: {
    faqDetail
  },
  mounted () {
    console.log(this.$t('lang'))
  },
  methods: {
    setKey (item) {
      this.key = item.key
      this.detail = item
    },
    logout () {
      localStorage.removeItem('userInfo')
      this.$router.go(0)
    }
  }
}
</script>

<style lang="less" scoped>
  .faqPage {
    display: flex;
    padding: 10px 150px 100px 165px;
    .nav {
      position: relative;
      width: 180px;
      height: 700px;
      margin-right: 35px;
      padding-left: 36px;
      padding-right: 24px;
      background: #202020;
      border-radius: 6px 0 0 6px;
      .caption {
        margin: 38px 0;
        font-size: 24px;
        line-height: 28px;
        color: #F6D9AA;
      }
      .navContainer {
        .navItem {
          margin-bottom: 30px;
          text-align: left;
          &:last-child {
            margin-bottom: 0;
          }
          img {
            width: 24px;
            margin-right: 18px;
          }
          .label {
            font-size: 18px;
            color: #686868;
          }
          .act {
            color: #F6D9AA;
          }
        }
      }
      .logout {
        position: absolute;
        bottom: 20px;
        left: 0;
        width: 100%;
        color: #F6D9AA;
        text-align: center;
      }
    }
    .faqContainer {
      position: relative;
      flex: 1;
      min-height: 700px;
      padding: 38px 120px;
      background: #202020;
      border-radius: 0 6px 6px 0;
      .faqDetail {
        padding: 38px 120px;
        background: #202020;
        border-radius: 0 6px 6px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FAQ/index.vue